// extracted by mini-css-extract-plugin
export default {"input":"daa-z","button":"eaa-z","selected":"faa-z","unavailable":"gaa-z","oos":"haa-z","paperCutDisabledOverlay":"iaa-z","image":"jaa-z"};